var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageColumn',{staticClass:"create-product-type",attrs:{"paddingMainContents":false}},[_c('Panel',{staticClass:"text-blue-800",attrs:{"title":"เพิ่มรายการสินค้า"}},[_c('CommonFormWithProductCreator',{attrs:{"edit":false}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }